import ResultadoPersonalC3ApiRepository from '@src/modules/resultados-personales-c3/infrastructure/ResultadoPersonalC3ApiRepository'
import GetResultadoPersonalC3 from '@src/modules/resultados-personales-c3/application/GetResultadoPersonalC3'
import GetResultadoPersonalById from '@src/modules/resultados-personales-c3/application/GetResultadoPersonalById'
import CreateResultadoPersonalC3 from '@src/modules/resultados-personales-c3/application/CreateResultadoPersonalC3'
import UpdateResultadoPersonalC3 from '@src/modules/resultados-personales-c3/application/UpdateResultadoPersonalC3'
import moment from 'moment'

const repository = new ResultadoPersonalC3ApiRepository()

function normalizaAMPM(fecha) {
  if (!fecha) return ''
  return fecha
    .replace('a. m.', 'am')
    .replace('p. m.', 'pm')
    .replace('a.m.', 'am')
    .replace('p.m.', 'pm')
    .replace('a.m', 'am')
    .replace('p.m', 'pm')
    .trim()
}

export default {
  namespaced: true,
  state: {
    resultados: [],
    resultadoSeleccionado: null,
  },
  getters: {
    getResultados: (state) => state.resultados,
    getResultadoSeleccionado: (state) => state.resultadoSeleccionado,
    getSusceptibleC3: (state) => {
      if (!state.resultados || state.resultados.length === 0) return null

      // Filtra resultados con fecha válida
      const resultadosValidos = state.resultados.filter((r) => !!r.fechaVigenciaEvaluacionC3)
      if (resultadosValidos.length === 0) return null

      // Ordena por fecha más reciente usando moment y normaliza AM/PM
      const sorted = [...resultadosValidos].sort((a, b) => {
        const fechaA = moment(normalizaAMPM(a.fechaVigenciaEvaluacionC3), 'DD/MM/YYYY HH:mm:ss a', true)
        const fechaB = moment(normalizaAMPM(b.fechaVigenciaEvaluacionC3), 'DD/MM/YYYY HH:mm:ss a', true)
        if (!fechaA.isValid() && !fechaB.isValid()) return 0
        if (!fechaA.isValid()) return 1
        if (!fechaB.isValid()) return -1
        return fechaB - fechaA
      })

      const latest = sorted[0]
      if (!latest) return null

      return latest.resultado && latest.resultado.trim().toLowerCase() === 'aprobado'
        ? { susceptible: true, fecha: latest.fechaVigenciaEvaluacionC3 }
        : { susceptible: false, fecha: latest.fechaVigenciaEvaluacionC3 }
    },
  },
  mutations: {
    SET_RESULTADOS(state, resultados) {
      state.resultados = resultados
    },
    SET_RESULTADO_SELECCIONADO(state, resultado) {
      state.resultadoSeleccionado = resultado
    },
    CLEAR_RESULTADOS(state) {
      state.resultados = []
    },
    CLEAR_RESULTADO_SELECCIONADO(state) {
      state.resultadoSeleccionado = null
    },
  },
  actions: {
    async fetchResultados({ commit }, idPersonal) {
      const resultados = await new GetResultadoPersonalC3(repository).execute(idPersonal)
      commit('SET_RESULTADOS', resultados)
    },
    async fetchResultadoById({ commit }, { idPersonal, idResultado }) {
      const resultado = await new GetResultadoPersonalById(repository).execute(idPersonal, idResultado)
      commit('SET_RESULTADO_SELECCIONADO', resultado)
    },
    async createResultado({ dispatch }, { idPersonal, resultado }) {
      await new CreateResultadoPersonalC3(repository).execute(idPersonal, resultado)
      await dispatch('fetchResultados', idPersonal)
    },
    async updateResultado({ dispatch }, { idPersonal, idResultado, resultado }) {
      await new UpdateResultadoPersonalC3(repository).execute(idPersonal, idResultado, resultado)
      await dispatch('fetchResultados', idPersonal)
    },
    clearResultados({ commit }) {
      commit('CLEAR_RESULTADOS')
    },
    clearResultadoSeleccionado({ commit }) {
      commit('CLEAR_RESULTADO_SELECCIONADO')
    },
  },
}
